import MetaHead from "components/base/MetaHead";
import HeroHeader from "components/sections/HeroHeader";
import MainContainer from "components/sections/MainContainer";
import NavFooter from "components/sections/NavFooter";
import Trans from "components/base/Trans";
import ExteriorDimensionsSection from "components/sections/ExteriorDimensionsSection";
import SpecsTable from "components/sections/SpecsTable";
import SmallTextSection from "components/sections/SmallTextSection";

export default function TechSpecs() {
  return (
    <MainContainer
      initialized
      navStyle={{ gradient: false, inverted: false }}
      bg="black.700"
    >
      <MetaHead title="LBL_TECH_SPECS_META_TITLE" />
      <HeroHeader
        imageSrc={{
          base: "/images/tech-specs-mobile.jpg",
          md: "/images/tech-specs.jpg",
        }}
        alt="HX50 Heliport - Hill Helicopters"
        subtitle="HX50"
        title={<Trans id="LBL_TECH_SPECS" />}
        titleType="headline_md"
        align="flex-end"
        minHeight="450px"
        height={["75vh", null, "80vh"]}
        noScrollHint
        noPadding
      />
      <SmallTextSection
        mt="120px"
        containerProps={{ py: "0px", pt: "0px", pb: "0px" }}
        textAlign="center"
        subtitle={<Trans id="HX50" />}
        title={<Trans id="LBL_TECH_SPECS_DIMENSIONS" />}
      />
      <ExteriorDimensionsSection noTitle />
      <SmallTextSection
        mt="120px"
        containerProps={{ py: "0px", pt: "0px", pb: "0px" }}
        textAlign="center"
        subtitle={<Trans id="GT50" />}
        title={<Trans id="LBL_TECH_SPECS_ENGINE" />}
      />
      <SpecsTable bg="black.700" center />
      <NavFooter
        previous={<Trans id="LBL_MENU_HDC" />}
        pathPrevious="/digital-cockpit"
        bgPrevious="/images/nav-footer/hdc.jpg"
        next={<Trans id="LBL_MENU_HOME" />}
        pathNext="/"
        bgNext="/images/nav-footer/home.jpg"
      />
    </MainContainer>
  );
}
